import { cloneDeep } from 'lodash';
import React, { useMemo } from 'react';
import { useGroupChatContext } from '../../context/groupchatContext';
import { getBaseUrl } from '../../helpers/utility';

const VezoCallBtn = ({ item }) => {

  const groupChatContext = useGroupChatContext();
  const { authData, setVezoCallData } = useMemo(() => ({
    authData: groupChatContext.authData,
    setVezoCallData: groupChatContext.setVezoCallData,
  }), [groupChatContext]);

  const startVezoCall = () => {
    if(authData?.is_provider){
      const params = {
        show: true,
        url: `${getBaseUrl().telemed_url}?mid=${item?.visit_key}&token=${authData.auth}&parent=provider_app&tz=${new Date().getTimezoneOffset()}&practice_id=${authData.practice?.id}&consent_signed=1`,
        last_call: cloneDeep(item)
      };
      setVezoCallData(params);
    }
    else{
      window.open(item?.visit_url, "_blank");
    }

  };

  return (
    <a onClick={startVezoCall}  rel="noopener noreferrer" className="text-blue-500 hover:underline cursor-pointer">
        {authData?.is_provider ? 'Start Call' : 'Join Call'}
    </a>
  );
};

export default VezoCallBtn;